import type { LucideIcon } from 'lucide-react';
import { Puzzle, BarChart3, Mail, MessageSquare, Shield, PenTool, Bot } from 'lucide-react';

export const categoryIcons: Record<string, LucideIcon> = {
  analytics: BarChart3,
  marketing: Mail,
  communication: MessageSquare,
  compliance: Shield,
  content: PenTool,
  ai: Bot,
  other: Puzzle,
};
